module.exports = __webpack_public_path__ + "static/media/03_theempress.0f31f3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/03_theempress.png
// module id = 66
// module chunks = 0